// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AgencySelectModal_boxModal__fjmP3 {
  animation: AgencySelectModal_init__LvIUy 0.3s;
  transition: 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
  font-size: 16px;
  overflow-y: scroll;
}

.AgencySelectModal_boxModal__fjmP3 .AgencySelectModal_exit__2KarL {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  margin-top: 20px;
  margin-bottom: 40px;
}

.AgencySelectModal_boxModal__fjmP3 .AgencySelectModal_exit__2KarL .AgencySelectModal_exitIcon__SLxSQ {
  transition: 0.3s;
}

.AgencySelectModal_boxModal__fjmP3 .AgencySelectModal_exit__2KarL .AgencySelectModal_exitIcon__SLxSQ:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.AgencySelectModal_boxModal__fjmP3 .AgencySelectModal_titleModal__Blqsu {
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  margin-top: 15px;
}

.AgencySelectModal_boxModal__fjmP3 .AgencySelectModal_titleModal__Blqsu p {
  font-size: 1.5rem;
  margin: 0;
}

.AgencySelectModal_boxModal__fjmP3 .AgencySelectModal_titleModal__Blqsu span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.AgencySelectModal_boxModal__fjmP3 .AgencySelectModal_loader__dpp37 {
  transition: 0.5s;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.AgencySelectModal_boxModal__fjmP3 .AgencySelectModal_data__UGWPy {
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.AgencySelectModal_boxModal__fjmP3 .AgencySelectModal_data__UGWPy .AgencySelectModal_tableContainer__ENr55 {
  animation: AgencySelectModal_init2__ThY6u 0.3s both 0.3s;
  min-height: 500px;
  border-radius: 5px;
}

.AgencySelectModal_boxModal__fjmP3 .AgencySelectModal_noresult__Fr-Zd {
  min-height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  font-weight: 300;
}

@media screen and (max-width: 900px) {
  .AgencySelectModal_boxModal__fjmP3 {
    background-color: rgba(238, 238, 238, 0.95);
    transition: 0.3s;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
}

@keyframes AgencySelectModal_init__LvIUy {
  0% {
    top: 55%;
    opacity: 0;
  }
  100% {
    top: 50%;
    opacity: 1;
  }
}

@keyframes AgencySelectModal_init2__ThY6u {
  0% {
    transform: translateX(30px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/AgencySelectModal/AgencySelectModal.module.css"],"names":[],"mappings":"AAAA;EACE,6CAAoB;EACpB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wDAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".boxModal {\n  animation: init 0.3s;\n  transition: 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-height: 90%;\n  border-radius: 10px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n  font-size: 16px;\n  overflow-y: scroll;\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n  margin-bottom: 40px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  margin-top: 15px;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.5rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .loader {\n  transition: 0.5s;\n  min-height: 500px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxModal .data {\n  transition: 0.5s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.boxModal .data .tableContainer {\n  animation: init2 0.3s both 0.3s;\n  min-height: 500px;\n  border-radius: 5px;\n}\n\n.boxModal .noresult {\n  min-height: 450px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 32px;\n  font-weight: 300;\n}\n\n@media screen and (max-width: 900px) {\n  .boxModal {\n    background-color: rgba(238, 238, 238, 0.95);\n    transition: 0.3s;\n    min-height: 100%;\n    border-radius: 0;\n    box-shadow: none;\n  }\n}\n\n@keyframes init {\n  0% {\n    top: 55%;\n    opacity: 0;\n  }\n  100% {\n    top: 50%;\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    transform: translateX(30px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `AgencySelectModal_boxModal__fjmP3`,
	"init": `AgencySelectModal_init__LvIUy`,
	"exit": `AgencySelectModal_exit__2KarL`,
	"exitIcon": `AgencySelectModal_exitIcon__SLxSQ`,
	"titleModal": `AgencySelectModal_titleModal__Blqsu`,
	"loader": `AgencySelectModal_loader__dpp37`,
	"data": `AgencySelectModal_data__UGWPy`,
	"tableContainer": `AgencySelectModal_tableContainer__ENr55`,
	"init2": `AgencySelectModal_init2__ThY6u`,
	"noresult": `AgencySelectModal_noresult__Fr-Zd`
};
export default ___CSS_LOADER_EXPORT___;
